import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getAccountPromo = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/stock-promotion/store/list` });

  return data;
};

export default getAccountPromo;
